export default "__VITE_ASSET__dyGgiwa___"